import React, { useEffect, useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { CRUDServices } from "../services/CRUDServices";
import { objectToFormData } from "../functions";
import bg from "../assets/images/bg.png";
import vs from "../assets/images/vs.png";
import t1 from "../assets/images/t1.png";
import t2 from "../assets/images/t2.png";
import n1 from "../assets/images/n1.png";
import q1 from "../assets/images/q1.png";
import first from "../assets/animations/first.mp4";
import Q1Overview from "../assets/animations/q1-overview-2026.mp4";
import Q2Overview from "../assets/animations/q2-overview-2026.mp4";
import Q3Overview from "../assets/animations/q3-overview-2026.mp4";
import Q4Overview from "../assets/animations/q4-overview-2026.mp4";
import second from "../assets/animations/second.mp4";
import third from "../assets/animations/third.mp4";
import fourth from "../assets/animations/fourth.mp4";
import gameOver from "../assets/animations/GameOver.mp4";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

const SingleLeague = () => {
  const location = useLocation();
  const matchData = location?.state?.data;

  const [homeTeamPlayersData, setHomeTeamPlayersData] = useState([]);
  const [awayTeamPlayersData, setAwayTeamPlayersData] = useState([]);
  const [quarter, setQuarter] = useState("");
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    if (timer === 16) setQuarter("Quarter1");
    if (timer === 29) setQuarter("Quarter2");
    if (timer === 42) setQuarter("Quarter3");
    if (timer === 55) setQuarter("Quarter4");
  }, [timer]);

  const getTeamPlayersInfo = async (teamId, team) => {
    var payload = objectToFormData({
      team_id: teamId,
      api_username: "FANDEX_DEV_TEAM",
      api_password: "FANDEX_PASSWORD_@#",
    });
    const response = await CRUDServices.POST("get_fantasy_players_by_team_id", payload);

    if (team === "home") {
      setHomeTeamPlayersData(response.data.data);
    } else {
      setAwayTeamPlayersData(response.data.data);
    }
  };

  useEffect(() => {
    getTeamPlayersInfo(matchData?.TeamIdhome, "home");
    getTeamPlayersInfo(matchData?.TeamIdaway, "away");
  }, [matchData]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const renderTabs = useMemo(() => {
    return (
      <Tabs activeKey={quarter} onSelect={(k) => setQuarter(k)} id="uncontrolled-tab-example" className="mb-3">
        {timer > 15 && (
          <Tab eventKey="Quarter1" title="Quarter1">
            <Table responsive="sm">
              <thead>
                <tr>
                  <th>Team</th>
                  <th>Score</th>
                  <th>Team</th>
                  <th>Score</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{matchData.TeamNamehome}</td>
                  <td>{matchData.Q1HomeScore}</td>
                  <td>{matchData.TeamNameaway}</td>
                  <td>{matchData.Q1AwayScore}</td>
                </tr>
              </tbody>
            </Table>
          </Tab>
        )}
        {timer > 28 && (
          <Tab eventKey="Quarter2" title="Quarter2">
            <Table responsive="sm">
              <thead>
                <tr>
                  <th>Team</th>
                  <th>Score</th>
                  <th>Team</th>
                  <th>Score</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{matchData.TeamNamehome}</td>
                  <td>{matchData.Q2HomeScore}</td>
                  <td>{matchData.TeamNameaway}</td>
                  <td>{matchData.Q2AwayScore}</td>
                </tr>
              </tbody>
            </Table>
          </Tab>
        )}
        {timer > 41 && (
          <Tab eventKey="Quarter3" title="Quarter3">
            <Table responsive="sm">
              <thead>
                <tr>
                  <th>Team</th>
                  <th>Score</th>
                  <th>Team</th>
                  <th>Score</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{matchData.TeamNamehome}</td>
                  <td>{matchData.Q3HomeScore}</td>
                  <td>{matchData.TeamNameaway}</td>
                  <td>{matchData.Q3AwayScore}</td>
                </tr>
              </tbody>
            </Table>
          </Tab>
        )}
        {timer > 54 && (
          <Tab eventKey="Quarter4" title="Quarter4">
            <Table responsive="sm">
              <thead>
                <tr>
                  <th>Team</th>
                  <th>Score</th>
                  <th>Team</th>
                  <th>Score</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{matchData.TeamNamehome}</td>
                  <td>{matchData.Q4HomeScore}</td>
                  <td>{matchData.TeamNameaway}</td>
                  <td>{matchData.Q4AwayScore}</td>
                </tr>
              </tbody>
            </Table>
          </Tab>
        )}
      </Tabs>
    );
  }, [quarter, timer, matchData]);

  return (
    <div className="sport-mid-card">
      <div className="sport-heading">
        <p className="mb-0">
          <NavLink to="/">
            <i className="fa fa-chevron-circle-left" aria-hidden="true"></i>
          </NavLink>{" "}
          | NBA LEAGUE
        </p>
      </div>

      <div className="parent">
        {timer < 4 && (
          <div>
            <img src={bg} alt="bg" className="img-fluid" />
            <div>
              <img src={q1} className="vs" alt="q1" />
              <img src={n1} className="team1" alt="teamname" />
              <img src={n1} className="team2" alt="teamname" />
              <img src={matchData?.image_url_home} className="teamlogo1" alt="teamname" />
              <img src={matchData?.image_url_away} className="teamlogo2" alt="teamname" />
              <p className="teamname1">0</p>
              <p className="teamname2 q-score">0</p>
            </div>
          </div>
        )}
        {timer > 3 && timer < 7 && (
          <div>
            <video src={first} width="100%" height="auto" loop muted autoPlay />
          </div>
        )}
        {timer > 6 && timer < 17 && (
          <div className="video-container">
            <video src={Q1Overview} width="100%" height="auto" loop muted autoPlay />
          </div>
        )}
        {timer > 16 && timer < 20 && (
          <div>
            <video src={second} width="auto" height="600px" loop muted autoPlay />
          </div>
        )}
        {timer > 19 && timer < 30 && (
          <div className="video-container">
            <video src={Q2Overview} width="100%" height="auto" loop muted autoPlay />
          </div>
        )}
        {timer > 29 && timer < 33 && (
          <div>
            <video src={third} width="auto" height="600px" loop muted autoPlay />
          </div>
        )}
        {timer > 32 && timer < 43 && (
          <div className="video-container">
            <video src={Q3Overview} width="100%" height="auto" loop muted autoPlay />
          </div>
        )}
        {timer > 42 && timer < 46 && (
          <div>
            <video src={fourth} width="auto" height="600px" loop muted autoPlay />
          </div>
        )}
        {timer > 45 && timer < 56 && (
          <div className="video-container">
            <video src={Q4Overview} width="auto" height="600px" loop muted autoPlay />
          </div>
        )}
        {timer > 55 && (
          <div>
            <video src={gameOver} width="100%" height="auto" loop muted autoPlay />
          </div>
        )}
      </div>

      <div className="p-3 single-detail">
        {timer >= 16 && <div className="accordian-tabs my-4">{renderTabs}</div>}
        
        {/* {timer >= 16 && (
          <Accordion>
            <Accordion.Item eventKey="4" className="mb-3">
              <Accordion.Header>
                <img src={matchData?.image_url_home} alt="matchimage" className="innerteam-logo" />
                {matchData?.TeamNamehome}
              </Accordion.Header>
              <Accordion.Body>
                <Table responsive="sm">
                  <thead>
                    <tr>
                      <th>Player Name</th>
                      <th>GS</th>
                      <th>MP</th>
                      <th>DRB</th>
                      <th>STL</th>
                      <th>BLK</th>
                      <th>TOV</th>
                      <th>PTS</th>
                      <th>ptsmin</th>
                    </tr>
                  </thead>
                  <tbody>
                    {homeTeamPlayersData?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.Playersname}</td>
                        <td>{item.GS}</td>
                        <td>{item.MP}</td>
                        <td>{item.DRB}</td>
                        <td>{item.STL}</td>
                        <td>{item.BLK}</td>
                        <td>{item.TOV}</td>
                        <td>{item.PTS}</td>
                        <td>{item.ptsmin}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5" className="mb-3">
              <Accordion.Header>
                <img src={matchData?.image_url_away} alt="teamlogo" className="innerteam-logo" />
                {matchData?.TeamNameaway}
              </Accordion.Header>
              <Accordion.Body>
                <Table responsive="sm">
                  <thead>
                    <tr>
                      <th>Player Name</th>
                      <th>GS</th>
                      <th>MP</th>
                      <th>DRB</th>
                      <th>STL</th>
                      <th>BLK</th>
                      <th>TOV</th>
                      <th>PTS</th>
                      <th>ptsmin</th>
                    </tr>
                  </thead>
                  <tbody>
                    {awayTeamPlayersData?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.Playersname}</td>
                        <td>{item.GS}</td>
                        <td>{item.MP}</td>
                        <td>{item.DRB}</td>
                        <td>{item.STL}</td>
                        <td>{item.BLK}</td>
                        <td>{item.TOV}</td>
                        <td>{item.PTS}</td>
                        <td>{item.ptsmin}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        )} */}
      </div>
    </div>
  );
};

export default SingleLeague;